module.exports = __webpack_public_path__ + "img/logo-plusdin-short.1f634e3a.svg";